import { GainType } from "@/data/types";
import ArmyBookItem from "./ArmyBookItem";
import ArmyBookRule from "./ArmyBookRule";
import ArmyBookWeapon from "./ArmyBookWeapon";

export default class ArmyBookGain {
  static Parse(obj) {
    if (obj instanceof ArmyBookItem || obj instanceof ArmyBookRule || obj instanceof ArmyBookWeapon)
      return obj;
    switch (obj.type) {
      case GainType.Item:
        return ArmyBookItem.FromObject(obj);
      case GainType.Rule:
        return ArmyBookRule.Parse(obj);
      case GainType.Weapon:
        return ArmyBookWeapon.FromObject(obj);
    }

    if (obj.attacks) return ArmyBookWeapon.FromObject(obj);
  }
}
